// extracted by css-extract-rspack-plugin
export default {"backdrop":"G8J4TIxrVmYvRdo2","launcher":"k3nZ4rK7HQwgXW2F","launcherIcon":"BlMsg9ER5b4r7cOz","launcherError":"kOg4EIhpx5cHImdi"};